export default __webpack_public_path__ + "static/media/home_page_video.38ca1b3f.mp4";